
<template>
     <el-input-number v-model="cell.deadline" controls-position="right" class="dynamic-input" @click.native="onClick" ref="dynamicInput"></el-input-number>
</template>

<script>
export default {
  name: 'DynamicInput',
  components: {
  },
  data() {
    return {

    }
  },
  props:{
    cell:{
        type:Object,
        default(){
            return{}
        }
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    onClick(e){  
        e.stopPropagation()
        this.$refs.dynamicInput.focus()   //保证在点击步数控制器的时候输入框始终聚焦
    }
  },
}
</script>

<style lang="scss" scoped>
// 给动态表单加定位浮在单元格上
.dynamic-input{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
}
</style>